import writeXlsxFile from "write-excel-file";
import { getGroups } from "../../../utils/services/group";

export async function createXlsx({
  idEvent,
  limit,
  countData,
  setFinishExport,
}) {
  const schema = [
    {
      column: "Id",
      type: String,
      value: (group) => group.id,
    },
    {
      column: "Descricao",
      type: String,
      value: (group) => group.name,
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getGroups({
      eventId: idEvent,
      offset: i,
      limit,
      search: "",
    });
    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0,
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = allRequestsPromises
    .map((e) => e.findOneGroupData.data)
    .flat();
  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "grupos.xlsx",
    });
  }
}
